const ArrowRightIcon = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.061 19.5615L17.121 12.5005L10.061 5.43945L7.93896 7.56145L12.879 12.5005L7.93896 17.4395L10.061 19.5615Z" fill="white" />
    </svg>
  );
};

export default ArrowRightIcon;
